const rates = [1, 2, 4, 8, 16];

export default rates;
